<section class="header-section">
    <h2>Modificar regla</h2>
    <button mat-icon-button (click)="clickCloseDialog()">
        <mat-icon>close</mat-icon>
    </button>
</section>
<section class="main-body">
    <form [formGroup]="updateRuleForm" (ngSubmit)="submitUpdate()">
        <div class="form-content">
            <mat-form-field class="single">
                <mat-label>Nombre</mat-label>
                <input matInput formControlName="name">
            </mat-form-field>
            <mat-form-field>
                <mat-label>N° Firmas</mat-label>
                <input matInput mask="separator" thousandSeparator="." formControlName="minApprovalRequired">
            </mat-form-field>
            <mat-form-field>
                <mat-label>Prioridad</mat-label>
                <input matInput mask="separator" thousandSeparator="." formControlName="priority">
            </mat-form-field>

            <mat-form-field class="single">
                <mat-label>Descripción</mat-label>
                <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Roles</mat-label>
                <mat-select formControlName="roles" [multiple]="true">
                    @for(role of rolesToAssign$ | async; track role) {
                        <mat-option [value]="role.roleId">
                            {{role.name}}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form-actions">
            <button type="submit" mat-raised-button color="primary" [disabled]="!updateRuleForm.valid">
                Modificar
            </button>
        </div>
    </form>
</section>